module.exports = __webpack_public_path__ + "static/media/Figure_S2.7fee268f.png";